import { CartItemResultActionsRenderTargetComponent } from './targets/cart-item-result-actions.render-target.component';
import { CartItemResultDescriptionRenderTargetComponent } from './targets/cart-item-result-description.render-target.component';
import { CartItemResultExtendedRenderTargetComponent } from './targets/cart-item-result-extended.render-target.component';
import { CartItemResultImagesRenderTargetComponent } from './targets/cart-item-result-images.render-target.component';
import { CartItemResultInfoRenderTargetComponent } from './targets/cart-item-result-info.render-target.component';
import { CartItemResultNoticeRenderTargetComponent } from './targets/cart-item-result-notice.render-target.component';
import { CartItemResultSummaryRenderTargetComponent } from './targets/cart-item-result-summary.render-target.component';
import { CartItemResultTitleRenderTargetComponent } from './targets/cart-item-result-title.render-target.component';

export const RenderTargetComponents = [
  CartItemResultActionsRenderTargetComponent,
  CartItemResultImagesRenderTargetComponent,
  CartItemResultDescriptionRenderTargetComponent,
  CartItemResultInfoRenderTargetComponent,
  CartItemResultSummaryRenderTargetComponent,
  CartItemResultTitleRenderTargetComponent,
  CartItemResultNoticeRenderTargetComponent,
  CartItemResultExtendedRenderTargetComponent,
];
